/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

//Importing sockets and Notifications stuff
import {GeneralSocketSystem} from '../components/notifications/GeneralSocketSystem.js';

import {PublicNotificationMessage} from '../components/notifications/PublicNotificationMessage.js';
import {PrivateNotificationMessage} from '../components/notifications/PrivateNotificationMessage.js';

import {AdminSupportChatSystem} from '../components/notifications/AdminSupportChatSystem.js';

// require('../bootstrap');

import Echo from "laravel-echo";

// console.log('ECHO', Echo, process.env.MIX_ENABLE_SOCKET_SYSTEM);

if (process.env.MIX_ENABLE_SOCKET_SYSTEM === 'true') {
//Setup Client socket listener
// window.ClientEcho = new Echo({
// 	broadcaster: 'socket.io',
// 	host: window.location.hostname + ':6001'
// });
	try {

		window.CoreEcho = new Echo({
			broadcaster: 'socket.io',
			host: window.location.hostname + ':6008'
		});
	}
	catch (e) {
		window.CoreEcho = null;
		console.error('window.CoreEcho is null');
	}
}
else {
	console.warn('Sockets are not activated. Make sure your .env file is correctly configured and supervisor is actively working on laravel-echo-server');
}

let token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
	window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
}
else {
	console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

/**********************************************************************/
//Sockets and Notifications with Global Scope
if (window.CoreEcho !== null) {
	window.GS = new GeneralSocketSystem({
		channel: process.env.MIX_GENERAL_SOCKET_SYSTEM_CHANNEL,
		updateTimeout: process.env.MIX_GENERAL_SOCKET_SYSTEM_TIMER * 1000
	});

	new PublicNotificationMessage({
		channel: process.env.MIX_PUBLIC_USER_NOTIFICATION_CHANNEL,
		event: process.env.MIX_USER_NOTIFICATION_EVENT
	});

	new PrivateNotificationMessage({
		channel: process.env.MIX_PRIVATE_USER_NOTIFICATION_CHANNEL,
		event: process.env.MIX_USER_NOTIFICATION_EVENT
	});

	if (process.env.MIX_ENABLE_CHAT_SYSTEM === 'true') {
		window.MessageSystem = new AdminSupportChatSystem({
			channel: process.env.MIX_CHAT_SYSTEM_CHANNEL,
			new_message_event: process.env.MIX_CHAT_SYSTEM_NEW_MESSAGE,
			update_support_event: process.env.MIX_CHAT_SYSTEM_UPDATE_SUPPORT_EVENT,
			update_me_timeout: process.env.MIX_CHAT_SYSTEM_UPDATE_ME_CALL_TIMEOUT,
			user_is_typing: process.env.MIX_CHAT_SYSTEM_USER_IS_TYPING,
			close_issue: process.env.MIX_CHAT_SYSTEM_CLOSE_ISSUE,
			action: '/sockets/chat_system',
			request_data: '/sockets/chat_system/data',
			local_storage_item: 'est_chat_system'
		});
	}
}
/**********************************************************************/


// WEBPACK FOOTER //
// ./resources/assets/js/config/echoServer.js